import PaperSelect from 'ember-paper/components/paper-select/component';
import PaperSelectEbdTrigger from 'ember-paper/components/paper-select/ebd-trigger/component';
import PaperSelectEbdContent from 'ember-paper/components/paper-select/ebd-content/component';
import PaperSelectEpsTrigger from 'ember-paper/components/paper-select/eps-trigger/component';
import PaperSelectOptions from 'ember-paper/components/paper-select/options/index';
import PaperSelectSearch from 'ember-paper/components/paper-select/search/index';
import PaperSelectNoMatchesMessage from 'ember-paper/components/paper-select/no-matches-message/component';
import PaperSelectSearchMessage from 'ember-paper/components/paper-select/search-message/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { classNames, tagName } from '@ember-decorators/component';

@classNames('page-select')
@tagName('div')
export default class PaperTableSelect extends PaperSelect {
  // publicAPI is power-select's `Select` object, handed back through
  // `@registerAPI` so the template can pass it to `ebdContentComponent`.
  // power-select defers the callback with `scheduleOnce('actions', ...)`, so
  // the write lands outside the render pass and a tracked field is safe here.
  @tracked publicAPI = null;

  @action
  registerAPI(publicAPI) {
    this.publicAPI = publicAPI;
  }

  // Component classes rather than strings: a string here reaches
  // `ensureSafeComponent` and trips `ensure-safe-component.string`.
  ebdTriggerComponent = PaperSelectEbdTrigger;
  ebdContentComponent = PaperSelectEbdContent;
  triggerComponent = PaperSelectEpsTrigger;
  optionsComponent = PaperSelectOptions;
  beforeOptionsComponent = PaperSelectSearch;
  noMatchesMessageComponent = PaperSelectNoMatchesMessage;
  searchMessageComponent = PaperSelectSearchMessage;
}
